module.exports = "/packs/step2_sp-31099c4035da19befe05afcaf4877ad7.png";